<template lang="pug">
  el-form(ref="form" @submit.native.prevent='' label-position="top" :rules="rules" :model="product")

    el-row(:gutter="40")
      el-col(:lg="17")
        el-form-item(label="Product name" prop="name")
          el-input(v-model.trim="product.name" size='large')

        el-form-item(label="Pricing" prop="price")
          el-input.price-input(v-model.number="product.price" size='large')
            i(slot="prepend") {{ activeCompanyCurrencySymbol }}

        el-row(:gutter="40")
          el-col(:lg="12")
            el-form-item(label="Select categories")
              .scroller(v-loading='relations.categories.loading')
                el-checkbox-group(v-model="categoryAssignments")
                  .scroller-item(v-for='category in relations.categories.list' :key='category.id')
                    el-checkbox(:label='category.id') {{ category.name }}

          el-col(:lg="12")
            el-form-item(label="Select locations")
              .scroller(v-loading='relations.locations.loading')
                el-checkbox-group(v-model="locationIds")
                  .scroller-item(v-for='laOption in locationAssignmentOptions' :key='laOption.location.id')
                    el-checkbox(:label='laOption.location.id') {{ laOption.location.name }}
                    el-form-item.location-price(label="Override price" v-if='laOption.model')
                      el-input(v-model.number='laOption.model.price')

      el-col(:lg="7")
        .schedule
          .schedule-header
            .schedule-status-label Status:
            el-switch(:width="100" v-model="published" on-text="Published" off-text="Draft" on-color="#7fc4be" off-color="#dd6e69")

          .schedule-content
            .schedule-actions
              el-button(v-if='!published' type='primary' native-type='submit' size='large' @click="onSave") Save as Draft
              el-button(v-if='published' type='primary' native-type='submit' size='large' @click="onSave") Save

              el-button(v-if='!published' type='success' native-type='submit' size='large' @click="onPublish") Publish
              el-button(v-if='showDelete' type='text' @click="onDelete") Delete

            slot(name='saveOptions')


</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  model: {
    prop: "product",
    event: "change"
  },
  props: {
    create: {
      type: Boolean,
      default: true
    },
    product: {
      type: Object,
      default: () => ({})
    },
    showDelete: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      formSubmitted: false,
      rules: {
        name: [{ required: true, message: "Required field", trigger: "blur" }],
        price: [
          {
            required: true,
            type: "number",
            message: "Please enter a valid number",
            trigger: "blur"
          }
        ]
      },
      relations: {
        locations: {
          loading: false,
          list: []
        },
        categories: {
          loading: false,
          list: []
        }
      }
    };
  },
  computed: {
    ...mapGetters("auth", ["activeCompanyCurrencySymbol"]),
    published: {
      get() {
        return this.product.status === "published";
      },
      set(val) {
        this.product.status = val ? "published" : "draft";
      }
    },
    categoryAssignments: {
      get() {
        if (!this.product || !this.product.categoryAssignments) {
          return [];
        }
        return this.product.categoryAssignments.map(ca => ca.category);
      },
      set(catIds) {
        this.product.categoryAssignments = catIds.map(catId => ({
          category: catId
        }));
      }
    },
    locationAssignmentOptions() {
      return this.relations.locations.list.map(loc => ({
        location: loc,
        model: this.product.locationAssignments
          ? this.product.locationAssignments.find(la => la.location === loc.id)
          : null
      }));
    },
    locationIds: {
      get() {
        if (!this.product || !this.product.locationAssignments) {
          return [];
        }
        return this.product.locationAssignments.map(la => la.location);
      },
      set(locIds) {
        const idsToAdd = locIds.filter(
          locId =>
            !this.product.locationAssignments.find(la => la.location === locId)
        );
        this.product.locationAssignments = this.product.locationAssignments.filter(
          la => locIds.includes(la.location)
        );
        this.product.locationAssignments.push(
          ...idsToAdd.map(locId => ({
            location: locId,
            price: null
          }))
        );
      }
    }
  },
  created() {
    this.loadRelations();
  },
  methods: {
    ...mapActions("products", ["fetchLocations", "fetchCategories"]),
    loadRelations() {
      this.relations.locations.loading = true;
      this.relations.categories.loading = true;

      this.fetchLocations({ params: { sort: "name" } }).then(data => {
        this.relations.locations.list = data;
        this.relations.locations.loading = false;
      });

      this.fetchCategories({ params: { sort: "name" } }).then(data => {
        this.relations.categories.list = data;
        this.relations.categories.loading = false;
      });
    },
    onSave() {
      this.$refs.form.validate(valid => {
        this.$emit("save", { valid });
      });
    },
    onDelete() {
      this.$emit("delete");
    },
    onPublish() {
      this.product.status = "published";
      this.onSave();
    }
  }
};
</script>

<style scoped lang="scss">
.price-input {
  width: 200px;
  i {
    padding: 0 4px;
    font-weight: bold;
  }
}

.scroller {
  min-height: 300px;
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #ddd;
  background: #efefef;
  border-radius: 3px;
}

.scroller-item {
  border-bottom: 1px solid #ddd;
  background: #fff;
  padding: 5px 15px;

  &:last-child {
    border-bottom: 0;
  }
}

.schedule {
  display: flex;
  flex-direction: column;
  border-radius: 0 0 2px 2px;
}

.schedule-header {
  flex: 0 0 auto;
  background: #eee;
  padding: 10px;
  display: flex;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 2px 2px 0 0;
}

.schedule-status-label {
  margin-right: 10px;
  font-family: "gilroyextrabold";
  text-transform: uppercase;
  font-weight: normal;
  letter-spacing: 0.05em;
  font-size: 14px;
  color: #2c3e50;
}

.schedule-content {
  background: white;
  padding: 15px;
  border: 1px solid #ddd;
  border-top: 0;
  border-radius: 0 0 2px 2px;

  :global(.el-form-item) {
    margin-bottom: 5px;
  }
}

.schedule-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  :global(.el-button) {
    width: 100%;
    margin-left: 0;
    margin-bottom: 5px;
  }
}

.location-price {
  display: flex;
  align-items: center;

  :global(.el-form-item__label) {
    text-transform: initial;
    margin-right: 10px;
    font-family: inherit;
  }
}
</style>
